/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  ArrowLeftOutlined, ArrowRightOutlined, CheckCircleOutlined, LinkOutlined, RedoOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Tag,
  Typography,
} from 'antd';
import { getEstadosGlobales } from 'api/catalogos';
import {
  deleteRolDeUsuario,
  getPermisosRoles,
  getRolDeUsuario,
  getRolesDeUsuario,
  patchRolDeUsuario,
  postRolDeUsuario,
} from 'api/estructuraOrganizacional/rolesDeUsuario';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { getRouteConfig, resolveRoutePermissions } from 'utils/routePermissions';

const { Text } = Typography;

const MODULO_LABELS = {
  nominas: 'Nóminas',
  entidad: 'Entidad',
  catalogos: 'Catálogos',
  usuarios: 'Usuarios',
  presupuesto: 'Presupuesto',
  tesoreria: 'Tesorería',
  contabilidad: 'Contabilidad',
  relojchecador: 'Reloj Checador',
  auth: 'Autenticación',
  sessions: 'Sesiones',
  admin: 'Administración',
  contenttypes: 'Tipos de Contenido',
};

const getAccionKey = (codename) => {
  if (!codename) return 'other';
  if (codename.startsWith('add_')) return 'add';
  if (codename.startsWith('view_')) return 'view';
  if (codename.startsWith('change_')) return 'change';
  if (codename.startsWith('delete_')) return 'delete';
  if (codename.startsWith('autorizar_')) return 'autorizar';
  if (codename.startsWith('cancelar_')) return 'cancelar';
  if (codename.startsWith('reactivar_')) return 'reactivar';
  if (codename.startsWith('recalcular_')) return 'recalcular';
  if (codename.startsWith('reactivarempleado_')) return 'reactivarempleado';
  if (codename.startsWith('inactivar_')) return 'inactivar';
  if (codename.startsWith('activar_')) return 'activar';
  if (codename.startsWith('clonar_')) return 'clonar';
  if (codename.startsWith('asistenteia_')) return 'asistenteia';
  if (codename.startsWith('dispersion_')) return 'dispersion';
  if (codename.startsWith('importar_')) return 'importar';
  if (codename.startsWith('generar_')) return 'generar';
  if (codename.startsWith('abrir_')) return 'abrir';
  if (codename.startsWith('cerrar_')) return 'cerrar';
  if (codename.startsWith('editarautorizado_')) return 'editarautorizado';
  if (codename.startsWith('editar_')) return 'editar';
  if (codename.startsWith('imprimir_')) return 'imprimir';
  if (codename.startsWith('consultarfea_')) return 'consultarfea';
  if (codename.startsWith('subirpdffea_')) return 'subirpdffea';
  if (codename.startsWith('verificarterminodevigencia_')) return 'verificarterminodevigencia';
  return 'other';
};

const ACCION_LABEL = {
  add: 'Agregar',
  view: 'Ver',
  change: 'Editar',
  delete: 'Eliminar',
  autorizar: 'Autorizar',
  cancelar: 'Cancelar',
  reactivar: 'Reactivar',
  recalcular: 'Recalcular',
  reactivarempleado: 'Reactivar Empleado',
  inactivar: 'Inactivar',
  activar: 'Activar',
  clonar: 'Clonar',
  asistenteia: 'Asistente IA',
  dispersion: 'Dispersión Bancaria',
  importar: 'Importar',
  generar: 'Generar',
  abrir: 'Abrir',
  cerrar: 'Cerrar',
  editarautorizado: 'Editar Autorizado',
  editar: 'Editar Nombramiento',
  imprimir: 'Imprimir',
  consultarfea: 'Consultar FEA',
  subirpdffea: 'Subir PDF a FEA',
  verificarterminodevigencia: 'Verificar Término de Vigencia',
  other: 'Otro',
};

const getObjeto = (name) => {
  const cleaned = name.replace(/^Can (add|view|change|delete)\s+/i, '');
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};

// Botones por defecto antes de que se resuelva una URL con modelo conocido
const DEFAULT_RESOLVER_ACTIONS = [
  { key: 'view', label: 'Ver' },
  { key: 'add', label: 'Agregar' },
  { key: 'change', label: 'Editar' },
  { key: 'delete', label: 'Eliminar' },
  { key: 'autorizar', label: 'Autorizar' },
  { key: 'cancelar', label: 'Cancelar' },
];

const columnsDual = [
  {
    titleText: 'Módulo', dataIndex: 'modulo', key: 'modulo', width: 130,
  },
  { titleText: 'Objeto', dataIndex: 'objeto', key: 'objeto' },
  {
    titleText: 'Acción', dataIndex: 'accion', key: 'accion', width: 90,
  },
];

export const rolesUsuariosPermission = {
  permissionModel: 'rol',
  catalogsModels: [],
  tabsModels: [],
};

const RolesDeUsuario = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [permisos, setPermisos] = useState([]);
  const [disableEditar, setDisableEditar] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [visibleInactivo, setVisibleInactivo] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedDisponiblesKeys, setSelectedDisponiblesKeys] = useState([]);
  const [selectedAsignadosKeys, setSelectedAsignadosKeys] = useState([]);
  const [extractDisponibles, setExtractDisponibles] = useState([]);
  const [extractAsignados, setExtractAsignados] = useState([]);
  const [urlInput, setUrlInput] = useState('');
  const [resolverActions, setResolverActions] = useState(['view', 'add', 'change']);
  const [resolvedResult, setResolvedResult] = useState(null);
  // Botones de acción dinámicos según el modelo del route resuelto
  const [modelActions, setModelActions] = useState([]);
  const lastModelRef = useRef(null);

  const formInstances = [form];

  // Enrich each permission with derived display fields
  const permisosConInfo = useMemo(() => permisos.map((p) => ({
    ...p,
    modulo: MODULO_LABELS[p.app_label] || p.app_label || '',
    objeto: getObjeto(p.name),
    accion: ACCION_LABEL[getAccionKey(p.codename)],
    _accionKey: getAccionKey(p.codename),
  })), [permisos]);

  const disponibles = useMemo(
    () => permisosConInfo.filter((p) => !selectedPermissions.includes(p.id)),
    [permisosConInfo, selectedPermissions],
  );

  const asignados = useMemo(
    () => permisosConInfo.filter((p) => selectedPermissions.includes(p.id)),
    [permisosConInfo, selectedPermissions],
  );

  // Refs apuntando siempre a los registros VISIBLES en cada tabla (tras filtros internos del Table)
  const extractDisponiblesRef = useRef([]);
  extractDisponiblesRef.current = extractDisponibles;
  const extractAsignadosRef = useRef([]);
  extractAsignadosRef.current = extractAsignados;

  // Limpiar selecciones que ya no pertenecen a la vista filtrada actual
  useEffect(() => {
    const ids = new Set(disponibles.map((p) => p.id));
    setSelectedDisponiblesKeys((prev) => prev.filter((id) => ids.has(id)));
  }, [disponibles]);

  useEffect(() => {
    const ids = new Set(asignados.map((p) => p.id));
    setSelectedAsignadosKeys((prev) => prev.filter((id) => ids.has(id)));
  }, [asignados]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRolesDeUsuario();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [_data, _estadosGlobales, _permisos] = await Promise.all([
        getRolesDeUsuario(),
        getEstadosGlobales(),
        getPermisosRoles(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setEstadosGlobales(_estadosGlobales);
        setPermisos(_permisos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const resetPermisosUI = () => {
    setSelectedDisponiblesKeys([]);
    setSelectedAsignadosKeys([]);
  };

  const resetResolver = () => {
    setUrlInput('');
    setResolvedResult(null);
    setResolverActions(['view', 'add', 'change']);
    setModelActions([]);
    lastModelRef.current = null;
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setDisableEditar(false);
    setSelectedPermissions([]);
    resetPermisosUI();
    resetResolver();
    form.resetFields();
  };

  const buildResolvedResult = (result, actionsUsed) => {
    if (!result.found) {
      setResolvedResult({ found: false });
      return;
    }
    const codenameSet = new Set(result.codenames);
    const matched = permisosConInfo.filter((p) => codenameSet.has(p.codename));
    const matchedCodes = new Set(matched.map((p) => p.codename));
    setResolvedResult({
      found: true,
      label: result.label,
      matched,
      matchedCodes,
      missing: result.codenames.length - matched.length,
      groups: result.groups,
    });
  };

  const resolveFromUrl = (actionsOverride) => {
    if (!urlInput.trim()) return;

    const config = getRouteConfig(urlInput.trim());
    const currentModel = config?.permissionModel || null;
    let actionsToUse = Array.isArray(actionsOverride) ? actionsOverride : resolverActions;

    // Cuando el modelo cambia, recalcular botones dinámicos desde permisos
    if (currentModel !== lastModelRef.current) {
      lastModelRef.current = currentModel;
      if (currentModel) {
        const suffix = `_${currentModel}`;
        const suffixLen = suffix.length;
        const seenActions = new Set();
        const newModelActions = permisos
          .filter((p) => p.codename.endsWith(suffix))
          .reduce((acc, p) => {
            const action = p.codename.slice(0, p.codename.length - suffixLen);
            if (seenActions.has(action)) return acc;
            seenActions.add(action);
            const label = ACCION_LABEL[action]
              || p.name
                .replace(/^(Puede|Can)\s+/i, '')
                .replace(new RegExp(`\\s+\\S*${currentModel}\\S*$`, 'i'), '')
                .trim()
              || action;
            acc.push({ key: action, label });
            return acc;
          }, []);
        // Incluir acciones custom de submodelos (ej. reactivar_descuentoempleado)
        (config?.subModels || []).forEach((sub) => {
          const subSuffix = `_${sub}`;
          const subSuffixLen = subSuffix.length;
          permisos
            .filter((p) => p.codename.endsWith(subSuffix))
            .forEach((p) => {
              const action = p.codename.slice(0, p.codename.length - subSuffixLen);
              if (seenActions.has(action)) return;
              seenActions.add(action);
              newModelActions.push({ key: action, label: ACCION_LABEL[action] || action });
            });
        });
        setModelActions(newModelActions);
        // Si no es un toggle, resetear selección a los defaults disponibles
        if (!Array.isArray(actionsOverride)) {
          const available = new Set(newModelActions.map((a) => a.key));
          actionsToUse = ['view', 'add', 'change'].filter((k) => available.has(k));
          setResolverActions(actionsToUse);
        }
      } else {
        setModelActions([]);
      }
    }

    buildResolvedResult(resolveRoutePermissions(urlInput.trim(), actionsToUse), actionsToUse);
  };

  const toggleResolverAction = (action) => {
    const newActions = resolverActions.includes(action)
      ? resolverActions.filter((a) => a !== action)
      : [...resolverActions, action];
    setResolverActions(newActions);
    if (urlInput.trim()) resolveFromUrl(newActions);
  };

  const addResolvedToRole = () => {
    if (!resolvedResult?.matched?.length) return;
    const ids = resolvedResult.matched.map((p) => p.id);
    setSelectedPermissions((prev) => [...new Set([...prev, ...ids])]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _rol = await getRolDeUsuario(match.id);
    setTimeout(() => {
      if (_rol) {
        form.resetFields();
        _rol?.estados_globales !== ESTATUS_ACTIVO ? setDisableEditar(true) : setDisableEditar(false);
        setSelectedPermissions(_rol?.permissions || []);
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_rol));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
        permissions: selectedPermissions,
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchRolDeUsuario(key, values) : postRolDeUsuario(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteRolDeUsuario(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = { selectedRowKeys, type: 'radio' };

  const onClickAdd = () => { onCancel(); setVisible(true); };
  const onClickDelete = () => { setVisibleAlert(true); };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Rol ya autorizado');
      }
      const _data = await getRolDeUsuario(key);
      const vals = { ..._data, estados_globales: ESTATUS_AUTORIZADO };
      const res = await patchRolDeUsuario(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const _data = await getRolDeUsuario(key);
      const vals = { ..._data, estados_globales: ESTATUS_ACTIVO };
      const res = await patchRolDeUsuario(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Toggle selection in the disponibles table
  const toggleDisponible = (record) => {
    setSelectedDisponiblesKeys((prev) => (
      prev.includes(record.id) ? prev.filter((id) => id !== record.id) : [...prev, record.id]
    ));
  };

  // Toggle selection in the asignados table
  const toggleAsignado = (record) => {
    setSelectedAsignadosKeys((prev) => (
      prev.includes(record.id) ? prev.filter((id) => id !== record.id) : [...prev, record.id]
    ));
  };

  const rowSelectionDisponibles = {
    selectedRowKeys: selectedDisponiblesKeys,
    type: 'checkbox',
    onSelect: toggleDisponible,
    // Usa extractData para respetar los filtros internos del Table (columnas, búsqueda interna)
    onSelectAll: (selected) => {
      setSelectedDisponiblesKeys(
        selected ? extractDisponiblesRef.current.map((r) => r.id) : [],
      );
    },
    disabled: disableEditar,
  };

  const rowSelectionAsignados = {
    selectedRowKeys: selectedAsignadosKeys,
    type: 'checkbox',
    onSelect: toggleAsignado,
    onSelectAll: (selected) => {
      setSelectedAsignadosKeys(
        selected ? extractAsignadosRef.current.map((r) => r.id) : [],
      );
    },
    disabled: disableEditar,
  };

  // Asignar: seleccionados con checkbox, o todos los visibles en tabla si no hay selección
  const addAllVisible = () => {
    const toAdd = selectedDisponiblesKeys.length > 0
      ? selectedDisponiblesKeys
      : extractDisponiblesRef.current.map((p) => p.id);
    setSelectedPermissions((prev) => [...new Set([...prev, ...toAdd])]);
    setSelectedDisponiblesKeys([]);
  };

  // Quitar: seleccionados con checkbox, o todos los visibles en tabla si no hay selección
  const removeAllVisible = () => {
    const toRemove = new Set(
      selectedAsignadosKeys.length > 0
        ? selectedAsignadosKeys
        : extractAsignadosRef.current.map((p) => p.id),
    );
    setSelectedPermissions((prev) => prev.filter((id) => !toRemove.has(id)));
    setSelectedAsignadosKeys([]);
  };

  const columns = [
    { titleText: 'Rol', dataIndex: 'name', key: 'name' },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      render: (val) => estadosGlobales?.find((e) => e.id === val)?.descripcion,
    },
  ];

  const rules = { required: [{ required: true, message: 'El campo es requerido' }] };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{ onClickAdd, onClickEdit: () => onClickEdit(), onClickDelete }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
              || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
            }
            customActions={[{
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'rol', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
            }, {
              onClick: () => setVisibleReactivar(true),
              permission: { model: 'rol', action: 'reactivar' },
              text: 'Reactivar',
              icon: <RedoOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
            }]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Rol de Usuario`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                allowSave={!disableEditar}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              {/* Nombre y estatus del rol */}
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="name" label="Nombre del Rol" rules={rules.required} hasFeedback>
                    <Input disabled={disableEditar} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    initialValue={ESTATUS_ACTIVO}
                    rules={rules.required}
                  >
                    <Select
                      keyProp="id"
                      labelProp="descripcion"
                      disabled={selectedRowKeys.length <= 0 || disableEditar}
                      activeInactive={!disableEditar}
                      dataSource={estadosGlobales}
                      onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Encabezado de permisos */}
              <Row style={{ marginBottom: 6 }}>
                <Col span={24}>
                  <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>
                    {`Permisos del Rol — ${selectedPermissions.length} asignados`}
                  </p>
                </Col>
              </Row>

              {/* Resolver de permisos por URL */}
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <Card
                    size="small"
                    style={{ background: '#fafafa', border: '0.5px solid #e8e8e8' }}
                    bodyStyle={{ padding: '6px 10px' }}
                  >
                    {/* URL + Resolver + Acciones — responsive */}
                    <Row gutter={[8, 4]} align="middle">
                      <Col flex="auto">
                        <Input
                          placeholder="http://localhost:3000/ruta"
                          value={urlInput}
                          onChange={(e) => {
                            setUrlInput(e.target.value);
                            if (!e.target.value) setResolvedResult(null);
                          }}
                          onPressEnter={resolveFromUrl}
                          prefix={<LinkOutlined style={{ color: '#aaa' }} />}
                          allowClear
                          disabled={disableEditar}
                        />
                      </Col>
                      <Col flex="none">
                        <Button
                          onClick={resolveFromUrl}
                          disabled={disableEditar || !urlInput.trim()}
                        >
                          Resolver
                        </Button>
                      </Col>
                      <Col flex="none">
                        <div
                          style={{
                            display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap',
                          }}
                        >
                          <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                            Acciones:
                          </Text>
                          {(modelActions.length ? modelActions : DEFAULT_RESOLVER_ACTIONS).map(({ key, label }) => (
                            <Button
                              key={key}
                              size="small"
                              type={resolverActions.includes(key) ? 'primary' : 'default'}
                              onClick={() => !disableEditar && toggleResolverAction(key)}
                            >
                              {label}
                            </Button>
                          ))}
                        </div>
                      </Col>
                    </Row>

                    {resolvedResult && (
                      <div style={{ marginTop: 8 }}>
                        {!resolvedResult.found ? (
                          <Text type="secondary">
                            {'⚠ URL no reconocida — agrega la ruta en '}
                            <code>src/utils/routePermissions.js</code>
                          </Text>
                        ) : (
                          <>
                            <Row align="middle" justify="space-between" style={{ marginBottom: 6 }}>
                              <Col>
                                <Text strong>{resolvedResult.label}</Text>
                                <Tag color="blue" style={{ marginLeft: 8 }}>
                                  {`${resolvedResult.matched.length} en BD`}
                                </Tag>
                                {resolvedResult.missing > 0 && (
                                  <Tag color="orange">
                                    {`${resolvedResult.missing} no encontrados`}
                                  </Tag>
                                )}
                              </Col>
                              <Col>
                                <Button
                                  type="primary"
                                  icon={<ArrowRightOutlined />}
                                  onClick={addResolvedToRole}
                                  disabled={disableEditar || !resolvedResult.matched.length}
                                >
                                  Agregar al Rol
                                </Button>
                              </Col>
                            </Row>
                            <div style={{ lineHeight: 2 }}>
                              {resolvedResult.groups.main.length > 0 && (
                                <>
                                  <Text type="secondary" style={{ marginRight: 4 }}>
                                    Modelo principal:
                                  </Text>
                                  {resolvedResult.groups.main.map((code) => (
                                    <Tag
                                      key={code}
                                      color={resolvedResult.matchedCodes.has(code) ? 'blue' : 'default'}
                                      style={{ margin: '2px 3px' }}
                                    >
                                      {code}
                                    </Tag>
                                  ))}
                                </>
                              )}
                              {resolvedResult.groups.sub.length > 0 && (
                                <>
                                  <Text type="secondary" style={{ marginLeft: 8, marginRight: 4 }}>
                                    Sub-modelos:
                                  </Text>
                                  {resolvedResult.groups.sub.map((code) => (
                                    <Tag
                                      key={code}
                                      color={resolvedResult.matchedCodes.has(code) ? 'green' : 'default'}
                                      style={{ margin: '2px 3px' }}
                                    >
                                      {code}
                                    </Tag>
                                  ))}
                                </>
                              )}
                              {resolvedResult.groups.cat.length > 0 && (
                                <>
                                  <Text type="secondary" style={{ marginLeft: 8, marginRight: 4 }}>
                                    Catálogos:
                                  </Text>
                                  {resolvedResult.groups.cat.map((code) => (
                                    <Tag
                                      key={code}
                                      style={{ margin: '2px 3px' }}
                                    >
                                      {code}
                                    </Tag>
                                  ))}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>

              {/* Doble tabla */}
              <Row gutter={4} align="middle">
                {/* Tabla izquierda: disponibles */}
                <Col xs={24} md={11}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {`Disponibles (${disponibles.length})${selectedDisponiblesKeys.length ? ` — ${selectedDisponiblesKeys.length} seleccionados` : ''}`}
                  </Text>
                  <Table
                    data={disponibles}
                    cols={columnsDual}
                    rowSelection={rowSelectionDisponibles}
                    handleOnRowClick={!disableEditar ? toggleDisponible : null}
                    allowExtractData
                    setExtractData={setExtractDisponibles}
                    allowExportPDF={false}
                    noControls
                  />
                </Col>

                {/* Botones de transferencia */}
                <Col
                  xs={24}
                  md={2}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                    padding: '0 4px',
                  }}
                >
                  <Button
                    icon={<ArrowRightOutlined />}
                    onClick={addAllVisible}
                    disabled={disableEditar || disponibles.length === 0}
                    title={selectedDisponiblesKeys.length ? `Asignar ${selectedDisponiblesKeys.length} seleccionados` : 'Asignar todos los visibles'}
                    size="small"
                  />
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={removeAllVisible}
                    disabled={disableEditar || asignados.length === 0}
                    title={selectedAsignadosKeys.length ? `Quitar ${selectedAsignadosKeys.length} seleccionados` : 'Quitar todos los visibles'}
                    size="small"
                  />
                </Col>

                {/* Tabla derecha: asignados */}
                <Col xs={24} md={11}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {`Asignados (${asignados.length})${selectedAsignadosKeys.length ? ` — ${selectedAsignadosKeys.length} seleccionados` : ''}`}
                  </Text>
                  <Table
                    data={asignados}
                    cols={columnsDual}
                    rowSelection={rowSelectionAsignados}
                    handleOnRowClick={!disableEditar ? toggleAsignado : null}
                    allowExtractData
                    setExtractData={setExtractAsignados}
                    allowExportPDF={false}
                    noControls
                  />
                </Col>
              </Row>

              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`el Rol ${form.getFieldValue('name')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          open={visibleAutorizar}
          contentTitle={`Autorizar el Rol ${form.getFieldValue('name')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          open={visibleReactivar}
          contentTitle={`Reactivar el Rol ${form.getFieldValue('name')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleInactivo(false);
          }}
          contentTitle={`Inactivar el Rol ${form.getFieldValue('name')}`}
          open={visibleInactivo}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default RolesDeUsuario;
